import React from 'react';

export default function ProgressBar({ steps, currentStep }) {
  return (
    <div className="mt-6">
      <div className="flex items-end justify-between gap-2">
        {steps.map((label, i) => {
          const isActive = i + 1 === currentStep;
          return (
            <div key={i} className="flex-1 text-center">
              <p className={`text-xs font-medium pb-1 ${isActive ? 'text-indigo-600' : 'text-gray-400'}`}>
                {label}
              </p>
              <div className={`h-0.5 rounded-full ${isActive ? 'bg-indigo-600' : 'bg-gray-200'}`} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
